import "./QuickActionsMenu.css";

import { EllipseGroupBlueIcon } from "../../../assets";
import { OrganisationTypeConstants } from "../../../constants";
import { useAuth } from "../../../useAuth";

interface QuickActionsMenuProps {
  label?: string;
  onClick: () => void;
}

export const QuickActionsMenu = ({ label = "Quick actions", onClick }: QuickActionsMenuProps): JSX.Element => {
  const { currentUserType } = useAuth();
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => (e.key === "Enter" ? onClick() : null)}
      className={`QuickActionsMenu ${currentUserType === OrganisationTypeConstants.ASSET_MANAGER ? "AssetManagerRounded" : ""}`}
    >
      <span>{label}</span>
      <div className="Divider" />
      <EllipseGroupBlueIcon />
    </div>
  );
};
